import { BehaviorSubject } from 'rxjs';

export function GetRand(length = 5) {
  return Math.round(Math.random() * Math.pow(10, length));
}

export function GetRandOf(max: number) {
  return Math.round(Math.random() * max);
}

export function CheckIfNeedReload(subject: BehaviorSubject<any>, id, forceReload: boolean, defaultValue: any) {
  if (forceReload) {
    return true;
  }
  const curValue = subject.getValue();
  if (!curValue?.id) {
    return true;
  }
  if (curValue.id != id) {
    if (defaultValue) {
      subject.next(defaultValue);
    }
    return true;
  }
  return false;
}

export class Logger {
  static log(...messages) {
    // eslint-disable-next-line no-console
    console.log(...messages);
  }
}

export function GetProp<T>(srcObject: T, key: keyof T): keyof T {
  return key;
}

export interface IShouldBeLoaded {
  clearPrevious: boolean;
  load: boolean;
  creation: boolean;
}

export function CommonIsShouldBeLoaded<T>(itemId: number | string, forceReaload: boolean,
                                          subject: BehaviorSubject<T | {}>): IShouldBeLoaded {
  // create mode
  if (itemId === 'new') {
    return {
      creation: true,
      load: false,
      clearPrevious: true
    }
  }

  // wrong route
  if (!itemId || isNaN(+itemId)) {
    return {
      creation: false,
      load: false,
      clearPrevious: true
    }
  }

  // previous item has another id
  const id = subject.getValue() ? subject.getValue()['id'] : null;
  if (itemId !== id) {
    return {
      creation: false,
      load: true,
      clearPrevious: true
    }
  }

  if (forceReaload) {
    return {
      creation: false,
      load: true,
      clearPrevious: false
    }
  }

  return {
    creation: false,
    load: false,
    clearPrevious: false
  }
}
